import { render, staticRenderFns } from "./QuestionsAnswer.vue?vue&type=template&id=5a5f4755&scoped=true"
import script from "./QuestionsAnswer.vue?vue&type=script&lang=js"
export * from "./QuestionsAnswer.vue?vue&type=script&lang=js"
import style0 from "./QuestionsAnswer.vue?vue&type=style&index=0&id=5a5f4755&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5f4755",
  null
  
)

export default component.exports